import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { CheckDuplicate } from 'components/CheckDuplicate';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useAddPage from 'hooks/useAddPage';
const MandateworldAddPage = (props) => {
		const app = useApp();
	const api = useApi();
	const utils = useUtils();
	
	//form validation rules
	const validationSchema = yup.object().shape({
		loanaccountno: yup.string().required().label($t('loanAccountNo')),
		accountholdername: yup.string().required().label($t('accountHolderName')),
		accountnumber: yup.string().required().label($t('accountNumber')),
		amounttype: yup.string().required().label($t('amountType')),
		accounttype: yup.string().required().label($t('accountType')),
		authtype: yup.string().required().label($t('authenticationType')),
		bankifsc: yup.string().required().label($t('ifsc')),
		collectionamount: yup.string().required().label($t('collectionAmount')),
		customeremail: yup.string().email().required().label($t('customerEmail')),
		customermobile: yup.string().required().label($t('customerMobile')),
		customername: yup.string().required().label($t('customerName')),
		principalamount: yup.string().required().label($t('principalAmount')),
		firstcollectiondate: yup.string().required().label($t('firstCollectionDate')),
		lastcollectiondate: yup.string().required().label($t('lastCollectionDate')),
		frequency: yup.string().required().label($t('frequency')),
		trxnid: yup.string().required().label($t('trxnid')),
		mdate: yup.string().required().label($t('mdate')),
		bankcode: yup.string().required().label($t('bankcode'))
	});
	
	//form default values
	const formDefaultValues = {
		loanaccountno: '', 
		accountholdername: '', 
		accountnumber: '', 
		amounttype: "M", 
		accounttype: '', 
		authtype: '', 
		bankifsc: '', 
		collectionamount: '', 
		customeremail: '', 
		customermobile: '', 
		customername: '', 
		principalamount: '', 
		firstcollectiondate: '', 
		lastcollectiondate: '', 
		frequency: '', 
		trxnid: utils.randomNum(10), 
		mdate: new Date(), 
		bankcode: '', 
	}
	
	//page hook where logics resides
	const pageController =  useAddPage({ props, formDefaultValues, afterSubmit });
	
	// destructure and grab what the page needs
	const { formData, resetForm, handleSubmit, submitForm, pageReady, loading, saving, inputClassName } = pageController;
	
	//event raised after form submit
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		resetForm();
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/mandateworld`);
		}
	}
	
	//auto fill other inputs on loanaccountno change
	async function loanaccountnoAutoFill(e, formik, index) {
		formik.handleChange(e);
		const val = e.target.value;
		const resp = await api.get(`components_data/mandateworld_loanaccountno_autofill?value=${val}`);
		const data = resp.data[0];
		if(data){
formik.setFieldValue('accountholdername', data.acname);
formik.setFieldValue('accountnumber', data.accountno);
formik.setFieldValue('bankifsc', data.ifsec);
formik.setFieldValue('collectionamount', data.payment);
formik.setFieldValue('customeremail', data.email);
formik.setFieldValue('customermobile', data.MobileNo);
formik.setFieldValue('customername', data.membername);
formik.setFieldValue('firstcollectiondate', data.startdate);
formik.setFieldValue('frequency', data.LoanPaymentFrequency);
formik.setFieldValue('lastcollectiondate', data.enddate);
formik.setFieldValue('principalamount', data.LoanAmount);
		}
	};
    //auto fill other inputs on loanaccountno change
    async function loanaccountnoAutoFill(e, formik, index) {
        formik.handleChange(e);
        const val = e.target.value;
        const resp = await api.get(`components_data/mandateworld_loanaccountno_autofill?value=${val}`);
        const data = resp.data[0];
        if(data){
            formik.setFieldValue('accountholdername', data.acname);
            formik.setFieldValue('accountnumber', data.accountno);
            formik.setFieldValue('bankifsc', data.ifsec);
            formik.setFieldValue('collectionamount', data.payment);
            formik.setFieldValue('customeremail', data.email);
            formik.setFieldValue('customermobile', data.mobileNo);
            formik.setFieldValue('customername', data.membername);
            formik.setFieldValue('firstcollectiondate', data.startdate);
            formik.setFieldValue('frequency', data.loanPaymentFrequency);
            formik.setFieldValue('lastcollectiondate', data.enddate);
            formik.setFieldValue('principalamount', data.loanAmount);
        }
    };
	
	// page loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	
	//page has loaded any required data and ready to render
	if(pageReady){
		return (
<main id="MandateworldAddPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('addNewMandate')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="col comp-grid" >
                    <div >
                        <Formik initialValues={formData} validationSchema={validationSchema} onSubmit={(values, actions) =>submitForm(values)}>
                            {(formik) => 
                            <>
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('loanAccountNo')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/loanaccountno_option_list_3"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="loanaccountno"     optionLabel="label" optionValue="value" value={formik.values.loanaccountno} onChange={(e)=>loanaccountnoAutoFill(e, formik)} options={response} label={$t('loanAccountNo')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.loanaccountno)}   />
                                                    <ErrorMessage name="loanaccountno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountHolderName')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountholdername"  onChange={formik.handleChange}  value={formik.values.accountholdername}   label={$t('accountHolderName')} type="text" placeholder={$t('enterAccountHolderName')}        className={inputClassName(formik?.errors?.accountholdername)} />
                                                <ErrorMessage name="accountholdername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountNumber')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountnumber"  onChange={formik.handleChange}  value={formik.values.accountnumber}   label={$t('accountNumber')} type="text" placeholder={$t('enterAccountNumber')}        className={inputClassName(formik?.errors?.accountnumber)} />
                                                <ErrorMessage name="accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amountType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amounttype"  onChange={formik.handleChange}  value={formik.values.amounttype}   label={$t('amountType')} type="text" placeholder={$t('enterAmountType')}        className={inputClassName(formik?.errors?.amounttype)} />
                                                <ErrorMessage name="amounttype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="accounttype"     optionLabel="label" optionValue="value" value={formik.values.accounttype} onChange={formik.handleChange} options={app.menus.accounttype} label={$t('accountType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.accounttype)}   />
                                                <ErrorMessage name="accounttype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('authenticationType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="authtype"     optionLabel="label" optionValue="value" value={formik.values.authtype} onChange={formik.handleChange} options={app.menus.authtype} label={$t('authenticationType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.authtype)}   />
                                                <ErrorMessage name="authtype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('ifsc')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bankifsc"  onChange={formik.handleChange}  value={formik.values.bankifsc}   label={$t('ifsc')} type="text" placeholder={$t('enterIfsc')}        className={inputClassName(formik?.errors?.bankifsc)} />
                                                <ErrorMessage name="bankifsc" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('collectionAmount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="collectionamount"  onChange={formik.handleChange}  value={formik.values.collectionamount}   label={$t('collectionAmount')} type="text" placeholder={$t('enterCollectionAmount')}        className={inputClassName(formik?.errors?.collectionamount)} />
                                                <ErrorMessage name="collectionamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customerEmail')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customeremail"  onChange={formik.handleChange}  value={formik.values.customeremail}   label={$t('customerEmail')} type="email" placeholder={$t('enterCustomerEmail')}        className={inputClassName(formik?.errors?.customeremail)} />
                                                <ErrorMessage name="customeremail" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customerMobile')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customermobile"  onChange={formik.handleChange}  value={formik.values.customermobile}   label={$t('customerMobile')} type="text" placeholder={$t('enterCustomerMobile')}        className={inputClassName(formik?.errors?.customermobile)} />
                                                <ErrorMessage name="customermobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customerName')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customername"  onChange={formik.handleChange}  value={formik.values.customername}   label={$t('customerName')} type="text" placeholder={$t('enterCustomerName')}        className={inputClassName(formik?.errors?.customername)} />
                                                <ErrorMessage name="customername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('principalAmount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="principalamount"  onChange={formik.handleChange}  value={formik.values.principalamount}   label={$t('principalAmount')} type="text" placeholder={$t('enterPrincipalAmount')}        className={inputClassName(formik?.errors?.principalamount)} />
                                                <ErrorMessage name="principalamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('firstCollectionDate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="firstcollectiondate"  onChange={formik.handleChange}  value={formik.values.firstcollectiondate}   label={$t('firstCollectionDate')} type="text" placeholder={$t('enterFirstCollectionDate')}        className={inputClassName(formik?.errors?.firstcollectiondate)} />
                                                <ErrorMessage name="firstcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastCollectionDate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastcollectiondate"  onChange={formik.handleChange}  value={formik.values.lastcollectiondate}   label={$t('lastCollectionDate')} type="text" placeholder={$t('enterLastCollectionDate')}        className={inputClassName(formik?.errors?.lastcollectiondate)} />
                                                <ErrorMessage name="lastcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('frequency')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="frequency"     optionLabel="label" optionValue="value" value={formik.values.frequency} onChange={formik.handleChange} options={app.menus.frequency} label={$t('frequency')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.frequency)}   />
                                                <ErrorMessage name="frequency" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('trxnid')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <CheckDuplicate value={formik.values.trxnid} apiPath="components_data/mandateworld_trxnid_exist">
                                                { (checker) => 
                                                <>
                                                <InputText name="trxnid" onBlur={checker.check} onChange={formik.handleChange}  value={formik.values.trxnid}   label={$t('trxnid')} type="text" placeholder={$t('enterTrxnid')}     disabled   className={inputClassName(formik?.errors?.trxnid)} />
                                                <ErrorMessage name="trxnid" component="span" className="p-error" />
                                                {(!checker.loading && checker.exist) && <small className="p-error">{$t('notAvailable')}</small>}
                                                {checker.loading && <small className="text-500">Checking...</small> }
                                                </>
                                                }
                                                </CheckDuplicate>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mdate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="mdate" showButtonBar className={inputClassName(formik?.errors?.mdate)} dateFormat="yy-mm-dd" value={formik.values.mdate} onChange={formik.handleChange} showIcon     disabled   />
                                                <ErrorMessage name="mdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankcode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/bankcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="bankcode"     optionLabel="label" optionValue="value" value={formik.values.bankcode} onChange={formik.handleChange} options={response} label={$t('bankcode')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.bankcode)}   />
                                                    <ErrorMessage name="bankcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)} className="p-button-primary" type="submit" label={$t('submit')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            </>
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}

//page props and default values
MandateworldAddPage.defaultProps = {
	primaryKey: 'mdid',
	pageName: 'mandateworld',
	apiPath: 'mandateworld/add',
	routeName: 'mandateworldadd',
	submitButtonLabel: $t('submit'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('createRecord'),
	msgAfterSave: $t('recordAddedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default MandateworldAddPage;
